import React from 'react'
import Breadcrumbs, {
  IBreadcrumb,
} from '@scentregroup/shared/hub-components/breadcrumbs'
import { BreadcrumbContainer } from '../../breadcrumb-container'
import { StoresBreadcrumbPath } from './types'

type StoresBreadcrumbProps = {
  path: StoresBreadcrumbPath
}

export const StoresBreadcrumb: React.FC<StoresBreadcrumbProps> = ({ path }) => {
  const breadcrumbs = React.useMemo<IBreadcrumb[]>(
    () =>
      path.reduce(
        (acc, { title, slug }, i) =>
          acc.concat([
            {
              title,
              linkTo:
                i < path.length - 1
                  ? `${acc[acc.length - 1].linkTo}/${slug}`
                  : undefined,
            },
          ]),
        [
          { title: 'Home', linkTo: '/' },
          {
            title: 'Find a store',
            linkTo: path.length > 0 ? '/stores' : undefined,
          },
        ] as IBreadcrumb[]
      ),
    [path]
  )

  return (
    <BreadcrumbContainer>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </BreadcrumbContainer>
  )
}
